export const CURRENCIES_INDEX_TOUR = {
  id: "currencies_index",
  steps: [
    {
      element: '[data-tour="currencies-create"]',
      popover: {
        title: "Nova moeda",
        description: "Adicione as moedas que sua conta aceita para cobrar assinaturas.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="currencies-list"]',
      popover: {
        title: "Moedas aceitas",
        description: "Código, nome e símbolo de cada moeda configurada.",
        side: "top",
      },
    },
  ],
};
